"use client";

import { useCallback, useState } from "react";

export const AWARENESS_STATES = {
  FOCUSED: "focused",
  ACTIVE: "active",
  DORMANT: "dormant",
} as const;

export type AwarenessState =
  (typeof AWARENESS_STATES)[keyof typeof AWARENESS_STATES];

const ACCENT_BY_AWARENESS: Record<AwarenessState, string> = {
  focused: "#C1A2FF",
  active: "#22c55e",
  dormant: "#64748b",
};

export function useAwarenessState(initial: AwarenessState = AWARENESS_STATES.FOCUSED) {
  const [awareness, setAwareness] = useState<AwarenessState>(initial);
  const accent = ACCENT_BY_AWARENESS[awareness] ?? "#C1A2FF";

  const setAwarenessState = useCallback((state: AwarenessState) => {
    setAwareness(state);
  }, []);

  return { awareness, accent, setAwarenessState, AWARENESS_STATES };
}
